module.exports = __webpack_public_path__ + "img/mobduration.f54e1191.svg";